<div class="dialog-header">
  <h2>{{ "cameraConsent." + brandKey + ".title" | translate }}</h2>
</div>

<mat-dialog-content cdkTrapFocus #scrollContent (scroll)="onScroll()">
  <p
    [innerHTML]="
      'cameraConsent.' + brandKey + '.intro'
        | translate : { brand: brandService.config.brandName }
    "
  ></p>

  <p>
    <strong>{{
      "cameraConsent." + brandKey + ".whatWeProcess" | translate
    }}</strong>
  </p>
  <p>{{ "cameraConsent." + brandKey + ".whatWeProcessDesc" | translate }}</p>
  <p>
    <em>{{
      "cameraConsent." + brandKey + ".whatWeProcessTags" | translate
    }}</em>
  </p>

  <p>
    <strong>{{ "cameraConsent." + brandKey + ".purpose" | translate }}</strong>
  </p>
  <p>{{ "cameraConsent." + brandKey + ".purposeDesc" | translate }}</p>

  <p>
    <strong>{{
      "cameraConsent." + brandKey + ".yourControl" | translate
    }}</strong>
  </p>
  <ul>
    <li>{{ "cameraConsent." + brandKey + ".yourControlItem1" | translate }}</li>
    <li>{{ "cameraConsent." + brandKey + ".yourControlItem2" | translate }}</li>
    <li>{{ "cameraConsent." + brandKey + ".yourControlItem3" | translate }}</li>
  </ul>

  <p>
    <strong>{{
      "cameraConsent." + brandKey + ".dataProtection" | translate
    }}</strong>
  </p>
  <ul>
    <li>
      {{ "cameraConsent." + brandKey + ".dataProtectionItem1" | translate }}
    </li>
    <li>
      {{ "cameraConsent." + brandKey + ".dataProtectionItem2" | translate }}
    </li>
  </ul>

  <p>
    <strong>{{
      "cameraConsent." + brandKey + ".dataSharing" | translate
    }}</strong>
  </p>
  <p>
    {{
      "cameraConsent." + brandKey + ".dataSharingDesc"
        | translate : { brand: brandService.config.brandName }
    }}
  </p>

  <p>
    <strong>{{
      "cameraConsent." + brandKey + ".aiTransparency" | translate
    }}</strong>
  </p>
  <p>{{ "cameraConsent." + brandKey + ".aiTransparencyDesc" | translate }}</p>

  <p>
    <strong>{{
      "cameraConsent." + brandKey + ".ageConfirmation" | translate
    }}</strong>
  </p>
  <p>{{ "cameraConsent." + brandKey + ".ageConfirmationDesc" | translate }}</p>

  <p>
    <a target="_blank" href="{{ brandService.config.privacyPolicyUrl }}">{{
      "cameraConsent." + brandKey + ".privacyPolicy" | translate
    }}</a>
    |
    <a target="_blank" href="{{ brandService.config.termsOfUseUrl }}">{{
      "cameraConsent." + brandKey + ".termsOfUse" | translate
    }}</a>
  </p>

  <button
    type="button"
    class="scroll-hint"
    [class.visible]="showScrollHint"
    (click)="scrollToBottom()"
    [attr.aria-label]="'a11y.scrollToConsent' | translate"
  >
    <span class="chevron"></span>
  </button>

  <div class="consent-section">
    <h3>{{ "cameraConsent." + brandKey + ".consents" | translate }}</h3>
    <mat-checkbox [(ngModel)]="requiredConsent">
      {{ "cameraConsent." + brandKey + ".requiredConsentLabel" | translate }}
    </mat-checkbox>
    <mat-checkbox [(ngModel)]="optionalDataImprovement">
      {{
        "cameraConsent." + brandKey + ".optionalDataImprovementLabel"
          | translate : { brand: brandService.config.brandName }
      }}
    </mat-checkbox>
    <mat-checkbox [(ngModel)]="optionalDataSharing">
      {{
        "cameraConsent." + brandKey + ".optionalDataSharingLabel" | translate
      }}
    </mat-checkbox>
    <mat-checkbox [(ngModel)]="optionalTracking">
      {{
        "cameraConsent." + brandKey + ".optionalTrackingLabel" | translate
      }}
    </mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-button
    mat-raised-button
    class="consent-submit-btn"
    [disabled]="!canSubmit"
    (click)="submitConsent()"
    cdkFocusInitial
    autoFocus
  >
    {{ "cameraConsent." + brandKey + ".submitButton" | translate }}
  </button>
</mat-dialog-actions>
